import { useState, useRef, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { getAllSportList } from "../../../../services/commonApiService/CommonApiService";
import { UserMenu, getBatchAthletes, getBatchList } from "../../../../services/adminApiService/batchManagementApi/BatchManagementApiService";
import ReactPaginate from "react-paginate";

const ParticipantsSection = ({
  selectedBatches,
  setSelectedBatches,
  selectedIndividuals,
  setSelectedIndividuals
}) => {

  const [isOpen, setIsOpen] = useState(true);
  const [activeTab, setActiveTab] = useState("batch");
  const [search, setSearch] = useState("");
  const [userTypeFilter, setUserTypeFilter] = useState("");
  const [sportFilter, setSportFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const [sportsList, setSportsList] = useState([]);
  const [sportsLoading, setSportsLoading] = useState(false);
  // const [userTypeList, setUserTypeList] = useState([]);
  // const [userTypeLoading, setUserTypeLoading] = useState(false);
  // const [saving, setSaving] = useState(false);

  const [athletes, setAthletes] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [batchList, setBatchList] = useState([]);

  const sectionRef = useRef(null);
  const prevScroll = useRef(0);

  const handleTabChange = (tab) => {
    prevScroll.current = window.scrollY;

    setActiveTab(tab);
    setCurrentPage(1);
    setSearch("");
    setSportFilter("");
    setUserTypeFilter("");

    setTimeout(() => {
      window.scrollTo(0, prevScroll.current);
    }, 0);
  };


  const toggleSection = () => {
    setIsOpen(prev => !prev);
  };


  // ================= SPORTS API =================
  useEffect(() => {
    const fetchSportsList = async () => {
      try {
        setSportsLoading(true);
        const response = await getAllSportList();
        setSportsList(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching sports list:", error);
      } finally {
        setSportsLoading(false);
      }
    };

    fetchSportsList();
  }, []);

  // useEffect(() => {
  //   const fetchUserTypes = async () => {
  //     try {
  //       setUserTypeLoading(true);
  //       const response = await UserMenu();
  //       setUserTypeList(response?.data?.data || []);
  //     } catch (error) {
  //       console.error("Error fetching user types:", error);
  //     } finally {
  //       setUserTypeLoading(false);
  //     }
  //   };

  //   fetchUserTypes();
  // }, []);

  /* ---------------- Fetch Data ---------------- */

  useEffect(() => {

    const fetchData = async () => {

      const payload =
        activeTab === "batch"
          ? {
            search,
            sports_id: sportFilter,
            page: currentPage,
            per_page: perPage
          }
          : {
            search,
            sport_id: sportFilter,
            // sub_category_type: userTypeFilter,
            page: currentPage,
            per_page: perPage
          };

      const res =
        activeTab === "batch"
          ? await getBatchList(currentPage, perPage, payload)
          : await getBatchAthletes(payload);

      const data = res?.data;

      if (activeTab === "batch") {
        setBatchList(data?.data || []);
      } else {
        setAthletes(data?.data || []);
      }

      setTotalRecords(data?.pagination?.total || 0);

    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [activeTab, search, sportFilter, userTypeFilter, currentPage, perPage]);


  const handleBatchSelect = (batch) => {

    const exist = selectedBatches.find(b => b.batch_id === batch.batch_id);

    if (exist) {
      setSelectedBatches(selectedBatches.filter(b => b.batch_id !== batch.batch_id));
    } else {
      setSelectedBatches([...selectedBatches, batch]);
    }

  };

  const handleIndividualSelect = (user) => {
    const exist = selectedIndividuals.find(u => u.id === user.id);

    if (exist) {
      setSelectedIndividuals(selectedIndividuals.filter(u => u.id !== user.id));
    } else {
      setSelectedIndividuals([...selectedIndividuals, user]);
    }
  };

  const handlePageChange = (event) => {
    setCurrentPage(event?.selected + 1);
  };


  return (
    <div className="card p-4 mt-4" ref={sectionRef}>

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center">

        <h5 className="mb-0">Participants</h5>

        <button
          className="btn"
          type="button"
          onClick={toggleSection}
        >
          {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </button>

      </div>


      {isOpen && (
        <>

          {/* TABS */}
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="participants-tabs mt-3">
                {["batch", "individual"].map(tab => (
                  <button
                  type="button"
                    key={tab}
                    className={`batch-tab-btn ${activeTab === tab ? "active" : ""}`}
                    onClick={() => handleTabChange(tab)}
                  >
                    {tab === "batch" ? "Batch" : "Individual"}
                  </button>
                ))}
              </div>
            </div>
          </div>



          {/* SEARCH + FILTER */}
          <div className="row mt-3 mb-3 g-2">

            {/* Search */}
            <div className="col-12 col-md-6">
              <input
                type="text"
                className="form-control"
                placeholder="Search atom id, user name, email..."
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />
            </div>

            {/* User Type */}
            {/* {activeTab === "individual" && (
              <div className="col-12 col-md-3">
                <select
                  className="form-select"
                  style={{ padding: '0.9rem' }}
                  value={userTypeFilter}
                  onChange={(e) => setUserTypeFilter(e.target.value)}
                >
                  {userTypeLoading ? (
                    <option>Loading...</option>
                  ) : (
                    <>
                      <option value="">User Type</option>
                      {userTypeList?.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.category_name}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>
            )} */}


            {/* Sport */}
            <div className="col-12 col-md-3">
              <select
                className="form-select"
                style={{ padding: '0.9rem' }}
                value={sportFilter}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSportFilter(e.target.value);
                }}
              >
                <option value="">Select Sport</option>
                {sportsList?.map((item) => (
                  <option key={item?.id} value={item?.sport_id}>
                    {item?.sport_name}
                  </option>
                ))}
              </select>
            </div>

          </div>


          {/* TABLE */}
          <div className="table-responsive">

            <table className="table">

              <thead className="bg-primary text-white">

                {activeTab === "batch" ? (
                  <tr>
                    <th></th>
                    <th>Batch Name</th>
                    <th>Sport</th>
                    <th>Athletes</th>
                  </tr>
                ) : (
                  <tr>
                    <th></th>
                    <th>Atom ID</th>
                    <th>User Name</th>
                    <th>Email</th>
                    {/* <th>User Type</th> */}
                    <th>Sport</th>
                  </tr>
                )}

              </thead>
              <tbody>

                {activeTab === "batch" ? (
                  batchList?.length > 0 ? (
                    batchList?.map(batch => (
                      <tr key={batch?.batch_id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedBatches.some(b => b.batch_id === batch.batch_id)}
                            onChange={() => handleBatchSelect(batch)}
                          />
                        </td>
                        <td>{batch?.batch_name}</td>
                        <td>{batch?.sport_name}</td>
                        <td>{batch?.total_athletes}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No records found
                      </td>
                    </tr>)
                ) :
                  (athletes?.length > 0 ? (
                    athletes?.map(a => (
                      <tr key={a?.id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedIndividuals.some(u => u.id === a.id)}
                            onChange={() => handleIndividualSelect(a)}
                          />
                        </td>
                        <td>#{a?.atom_id}</td>
                        <td>{`${a?.first_name || ""} ${a.middle_name || ""} ${a.last_name || ""}`}</td>
                        <td>{a?.email}</td>
                        {/* <td>{a?.user_type_name}</td> */}
                        <td>{a?.sport_name}</td>
                      </tr>
                    ))) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No records found
                      </td>
                    </tr>

                  ))}

              </tbody>
            </table>
          </div>


          {/* PAGINATION */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <ReactPaginate
              nextLabel="next >"
              onPageChange={handlePageChange}
              pageRangeDisplayed={5}
              marginPagesDisplayed={2}
              pageCount={Math.ceil(totalRecords / perPage)}
              previousLabel="< previous"
              containerClassName="pagination d-flex flex-wrap"
              activeClassName="active"
              pageClassName="page-item mx-1 my-1"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link mx-1 my-1"
              nextClassName="page-item mx-1 my-1"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item mx-1 my-1"
              breakLinkClassName="page-link"
              forcePage={currentPage - 1}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ParticipantsSection;